import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8935bd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "background" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = { id: "headerBtnContainer" }
const _hoisted_4 = { id: "selectSearchContainer" }
const _hoisted_5 = { class: "selectContainer" }
const _hoisted_6 = { class: "selectContainer" }
const _hoisted_7 = { id: "inputSearchContainer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, "查询职业", -1))
const _hoisted_9 = { id: "mainBody" }
const _hoisted_10 = { id: "IncludingColleges" }
const _hoisted_11 = { class: "collegesLine1" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "collegesLine2" }

import {ref, reactive, nextTick} from 'vue'
  import {ElMessage} from 'element-plus';
  import {ElScrollbar} from 'element-plus'
  import {Search} from '@element-plus/icons-vue'
  import {
    getCollegeInfoByInput,
    getCollegeInfoBySelect,
    getCollegeInfoBySelect2,
    getIndustryList,
    getOccList,
    getOccTypeByIndustry,
    getSelectSerachCity,
    getSelectSerachProvince,
    searchGetAllColleges,
    searchGetColleges
  } from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionSearch',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();
  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileProfessionSearch')
  }

  let professionSearchInfo = reactive({
    occName: '',
    industry: '',
    industryArray: [],
    occType: '',
    occTypeArray: [],
    professionArray: [],
  });

  //获取 el-scrollbar滚动条 id
  let mainBodyScrollbar = ref();

  //刚进页面 获取 头部第一个下拉框的值
  getIndustryList('/getIndustryList').then((res) => {
    professionSearchInfo.industryArray = [];
    professionSearchInfo.industryArray = res.data.data
  });


  //第一个下拉框有变动 获取第二个下拉框的值
  let select1Change = (val: any) => {
    professionSearchInfo.occType = '';
    getOccTypeByIndustry('/getOccTypeByIndustry', {
      params: {
        industry: val
      }
    }).then((res) => {
      professionSearchInfo.occTypeArray = [];
      professionSearchInfo.occTypeArray = res.data.data;

    })
    pageChange()
  };

  let select2Change = () => {
    pageChange()
  }


  let pageChange = () => {
    nextTick(() => {
      mainBodyScrollbar.value!.setScrollTop(0)
    })
    getOccList('/getOccList', {
      params: {
        industry: professionSearchInfo.industry,
        occType: professionSearchInfo.occType,
        occName: professionSearchInfo.occName,
      }
    }).then((res) => {
      professionSearchInfo.professionArray = [];
      professionSearchInfo.professionArray = res.data.data;
    })
  }

  pageChange()

  //==========点击 跳转 页面================//
  let goMajorSituation =(occId:any)=>{
    window.open('/ProfessionPage/'  + occId, '_blank')
  }



  let goTransferPage = () => {
    window.open('/TransferPage/0101', '_blank')
  };

  let goMajorSearch = () => {
    window.open('/MajorSearch')
  };

  let goCollegeSearch = () => {
    window.open('/')
  };




return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                modelValue: _unref(professionSearchInfo).industry,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(professionSearchInfo).industry) = $event)),
                clearable: "",
                onClear: _unref(pageChange),
                onChange: _unref(select1Change),
                placeholder: "选择行业",
                "popper-class": "elPopperSelect"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).industryArray, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: item,
                      label: item
                    }, null, 8, ["value", "label"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue", "onClear", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _unref(professionSearchInfo).occType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(professionSearchInfo).occType) = $event)),
                placeholder: "选择职业类别",
                clearable: "",
                onClear: _unref(pageChange),
                onChange: _unref(select2Change),
                "popper-class": "elPopperSelect"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).occTypeArray, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: item,
                      label: item
                    }, null, 8, ["value", "label"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue", "onClear", "onChange"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              id: "majorsInquireBtn",
              onClick: _unref(goTransferPage)
            }, {
              default: _withCtx(() => [
                _createTextVNode("专业查询")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(goMajorSearch)
            }, {
              default: _withCtx(() => [
                _createTextVNode("专业搜索")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_input, {
              "prefix-icon": _unref(Search),
              placeholder: "请输入职业名称",
              clearable: "",
              onClear: _unref(pageChange),
              modelValue: _unref(professionSearchInfo).occName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(professionSearchInfo).occName) = $event)),
              style: {"width":"180px"},
              onKeyup: _withKeys(_unref(pageChange), ["enter"])
            }, null, 8, ["prefix-icon", "onClear", "modelValue", "onKeyup"]),
            _createVNode(_component_el_button, {
              id: "inputSearchButton",
              onClick: _unref(pageChange)
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "deepBlueBtn",
              onClick: _unref(goCollegeSearch)
            }, {
              default: _withCtx(() => [
                _createTextVNode("院校查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(ElScrollbar), {
        ref_key: "mainBodyScrollbar",
        ref: mainBodyScrollbar
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).professionArray, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "collegesContainer",
                key: item.occId
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_unref(goMajorSituation)(item.occId))
                  }, _toDisplayString(item.occName), 9, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_row, { style: {"height":"100%","display":"flex","align-items":"center"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createTextVNode("行业：" + _toDisplayString(item.industry), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createTextVNode("职业类别：" + _toDisplayString(item.occType), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createTextVNode("岗位薪资：" + _toDisplayString(item.positionSalary), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128)),
            (_unref(professionSearchInfo).professionArray.length == 0)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  style: {"margin-top":"100px"},
                  description: "暂无数据"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})